import React from 'react';

import styled from '@emotion/styled';
import logo from '../../images/logo.png';
import NavigationList from './NavigationList';
import LogoAnchor from '../atoms/LogoAnchor';

const LogoWrapper = styled.h1`
float: left;
    margin-top: 19px;
`;

const LogoImg = styled.img`
    margin-top: -2px;
    height: 22px;
    margin-right: 10px;
`;
const NavigationHeader = () => (
  <>
    <div className="navigation-bar">
      <div id="navigation-container">
        <LogoWrapper>
          <LogoAnchor href="/" target="_self">
            <LogoImg src={logo} alt="로고" />
            {process.env.REACT_APP_LOGO_TITLE}
          </LogoAnchor>
        </LogoWrapper>
        <NavigationList />

      </div>
      <div style={{ clear: 'both' }} />
    </div>
  </>
);

export default NavigationHeader;
